export const MANUAL = 'manual'
export const AUTO = 'auto'
export const AUTO_MEMBER = 'auto_member'
export const SUGGESTION_ACCEPTED = 'suggestion_accepted'
export const REPEAT = 'repeat'
export const REPEAT_SUGGESTION = 'repeat_suggestion'
export const NORMALIZED_SUGGESTION = 'normalized_suggestion'
export const SEMANTIC_SUGGESTION = 'semantic_suggestion'
export const SUGGESTION = 'suggestion'

export type TaskLabelStatus =
  | typeof MANUAL
  | typeof AUTO
  | typeof AUTO_MEMBER
  | typeof SUGGESTION_ACCEPTED
  | typeof REPEAT
  | typeof SUGGESTION
  | typeof REPEAT_SUGGESTION
  | typeof NORMALIZED_SUGGESTION
  | typeof SEMANTIC_SUGGESTION

export const SUGGESTION_STATUSES = [SUGGESTION, REPEAT_SUGGESTION, NORMALIZED_SUGGESTION, SEMANTIC_SUGGESTION] as const

export const isSuggestionStatus = (status: string): boolean => (
  (SUGGESTION_STATUSES as readonly string[]).includes(status)
)
